<template>
    <div class="padding">

        <h2>Авторизация</h2>
        <hr/>
        <div class="callout alert" v-if="error">
            <p>{{ error }}</p>
        </div>
        <p>Для авторизации используйте логин и пароль от личного кабинеты Платформы LP.<br/><br/><br/></p>
        <form @submit.prevent="submit()">
            <div class="form-group">
                <input
                        type="text"
                        class="form-control style-input"
                        placeholder="Введите логин"
                        v-model="credentials.username"
                >
            </div>
            <div class="form-group">
                <input
                        type="password"
                        class="form-control style-input"
                        placeholder="Введите пароль"
                        v-model="credentials.password"
                >
            </div>
            <button class="button">Войти</button>
        </form>
    </div>
</template>

<script>
    import auth from '../auth/index'

    export default {
        data() {
            return {
                // We need to initialize the component with any
                // properties that will be used in it
                credentials: {
                    username: '',
                    password: ''
                },
                error: ''
            }
        },
        mounted() {
            if (this.$route.query.message) {
                this.error = this.$route.query.message
            }
        },
        methods: {
            submit() {
                var credentials = {
                    login: this.credentials.username,
                    password: this.credentials.password
                };
                // We need to pass the component's this context
                // to properly make use of http in the auth service
                auth.login(this, credentials, this.$route.query.redirect || '/ideas/')
            }
        }

    }
</script>


// WEBPACK FOOTER //
// Login.vue?05f7cfae